// 提供的行情组件
import handicap from './view/vue/handicap.vue';                                     // 盘口
import quoteGraph from './view/vue/quotegraph.vue';                                 //分时K线指标
import transDetail from './view/vue/transDetail.vue';                               // 成交明细
import constituentsRank from './view/vue/constituentsRank.vue';                     // 成分股排行
import indexCompare from './view/vue/indexCompare.vue';                             // 指数比较
import handicapPrice from './view/vue/handicapPrice.vue';                           // 盘口价格
// 一些其他依赖
import { OpenAPI } from './controller/datamanager/api';         // 公共请求
import filters from '../packages/view/script/filters';          // 过滤器
const echarts = require('echarts/lib/echarts');                 // echarts
require('echarts/lib/chart/line');                              // echarts折线图
require("echarts/lib/component/tooltip");                       // echarts提示框
require("echarts/lib/component/dataZoom");                      // echarts滑块
require('echarts/lib/component/dataZoomSlider');                // echarts外部滑块
require("echarts/lib/component/legend");                        // echarts图例

import Button from 'element-ui/lib/button';                     // element按钮
import Table from 'element-ui/lib/table';                       // element表格
import TableColumn from 'element-ui/lib/table-column';          // element表格列
import ButtonGroup from 'element-ui/lib/button-group';          // element按钮组
import RadioButton from 'element-ui/lib/radio-button';          // element单选按钮
import RadioGroup from 'element-ui/lib/radio-group';            // element单选按钮组
import Select from 'element-ui/lib/select';                     // element下拉选择
import Option from 'element-ui/lib/option';                     // element下拉选择项
import Input from 'element-ui/lib/input';                       // element输入框
import Cascader from 'element-ui/lib/cascader';                 // element级联选择器
import CascaderPanel from 'element-ui/lib/cascader-panel';      // element级联面板
import Tree from 'element-ui/lib/tree';                         // element树

const components = [
  handicap,quoteGraph,transDetail,constituentsRank,indexCompare,handicapPrice,
  Button,
  Table,
  TableColumn,
  ButtonGroup,
  RadioButton,
  RadioGroup,
  Select,
  Option,
  Input,
  Cascader,
  CascaderPanel,
  Tree,
  // fxSpotOptionDelta,
  // fxSpotOptionOffer,
  // fxSpotOptionWava,
  // fxOptionVolatCurve,
  // fxSwapBusiCurve,
  // fxSwapCurve,
]
const install = function (Vue) {
  Vue.prototype.vueFunction=vueFunction
  Vue.prototype.OpenAPI = OpenAPI
  Vue.prototype.echarts = echarts
  for (let key in filters) {
    Vue.filter(key, filters[key]);
  }
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}
// 自动注册组件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default{
  install,
  handicap,quoteGraph,transDetail,constituentsRank,indexCompare,handicapPrice,
  Button,
  Table,
  TableColumn,
  ButtonGroup,
  RadioButton,
  RadioGroup,
  Select,
  Option,
  Input,
  Cascader,
  CascaderPanel,
  Tree,
  // fxSpotOptionDelta,
  // fxSpotOptionOffer,
  // fxSpotOptionWava,
  // fxOptionVolatCurve,
  // fxSwapBusiCurve,
  // fxSwapCurve,
}
